export default {
  isIntroCollapsed: state => () => state.collapsed
};
